import { currentClientConfig } from '/@/config/env'

let websocketURL = ''; let websocketPushURL = ''; let baseImgUrl = ''; let baseUrl = ''
if (window.location.protocol === 'http:') {
  if (window.location.hostname === 'localhost' || window.location.hostname === '192.168.31.22') {
    websocketURL = `ws://127.0.0.1:6099/${import.meta.env.VITE_UAV_MODE === 'true' ? 'dj-prod-api/' : 'api/'}api/v1/ws`
    baseImgUrl = 'http://127.0.0.1:19080/dj-cloud-bucket/'
    baseUrl = `/${import.meta.env.VITE_UAV_MODE === 'true' ? 'dj-prod-api/' : 'api/'}`
  } else {
    baseImgUrl = '/dj-cloud-bucket/'
    websocketURL = `ws://${window.location.host}/${import.meta.env.VITE_UAV_MODE === 'true' ? 'dj-prod-api/' : 'api/'}api/v1/ws`
    websocketPushURL = `ws://${window.location.host}/prod-api/perception/9527`
    baseUrl = `http://${window.location.host}/${import.meta.env.VITE_UAV_MODE === 'true' ? 'dj-prod-api/' : 'api/'}`
  }
} else {
  baseImgUrl = '/dj-cloud-bucket/'
  websocketURL = `wss://${window.location.host}/${import.meta.env.VITE_UAV_MODE === 'true' ? 'dj-prod-api/' : 'api/'}api/v1/ws`
  websocketPushURL = `wss://${window.location.host}/prod-api/perception/9527`
  baseUrl = `https://${window.location.host}/${import.meta.env.VITE_UAV_MODE === 'true' ? 'dj-prod-api/' : 'api/'}`
}

export const CURRENT_CONFIG = {
  title: '无人机AI智慧巡查平台',
  appId: '138524', // You need to go to the development website to apply.
  appKey: '5c382ff387f3f3088f95311e440ae86', // You need to go to the development website to apply.
  appLicense: 'dgbW/CilawfQsVf6JhHLi8O1zZ0B0oElLGQRLgw+muCKMEMSt4AdBhtY2sHJFBECQL2GNIvojWdJyPqx3fOF+mFAbRT5FXSzizxh02It8MHDH0mZqDJxPVBM6jh5qRtOXlpHjFt4uYzjCFTJj5MkPalMT4RmZb46VFlL7MetAvw=', // You need to go to the development website to apply.
  amapKey: '5e00e01d2d2b6ca9e1eed533a15572e4',
  securityJsCode: 'b12733252955210a76ae57f84abad837',
  tiandituKey: 'f13558063a1569e3145b64d37cf252a3',
  cesiumToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJjYzA0NWIwMi1hNjRkLTQ1NDQtYjkxMy1iNmI1NmY1YTYxZTgiLCJpZCI6MzYzNTM5LCJpYXQiOjE3NjQwMzczMTd9.u6qn0WLYDO72zg6x9laqrO9725NygHccvcnA9wH6aOk',
  // http
  baseURL: baseUrl, // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: websocketURL, // Example: 'ws://192.168.1.1:6789/api/v1/ws'
  websocketPushURL: websocketPushURL, // Example: 'ws://192.168.1.1:6789/api/v1/ws'
  websocketDeepseekURL: `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/${import.meta.env.VITE_UAV_MODE === 'true' ? 'dj-prod-api/' : 'api/'}ws/chat/`,
  // websocketDeepseekURL: 'wss://drone.kfktec.cn:5085/ws/chat/',
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  // rtmpURL: 'rtmp://qbj.jszhcs.cn:9595/live/', // Example: 'rtmp://192.168.1.1/live/'
  rtmpURL: '', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',
  // You can apply on the AMap website.
  videoQualityValue: 4, // 默认超清；0-自适应，1-流畅，2-标准，3-高清，4-超清
  customerNo: '', // 算法客户编号
  geoJson: '', // 乡镇边界
  mapCenter: [104.063353, 30.660058], // 地图中心点
  liveUrlObj: {
    dock: '',
    drone: '',
    droneFpv: ''
  }, // 直播地址
  cameraObj: {
    dock: '165-0-7',
    drone: '81-0-0',
    droneFpv: ''
  }, // 摄像头编号
  imgUrl: baseImgUrl, // 图片地址
  dronePlayer: '', // 无人机播放地址
  target_height: 660, // 海拔
}
